import { Button, onSocialNetworkConnection, SocialConnect } from '@hub/shared'
import { useLayoutEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import HeaderComponent from './components/header/header.component'

import './empty-social-networks.page.scoped.scss'

const WIDTH_FOR_MOBILE = 991
const HEIGHT_IPHONE_14_PRO_MAX = 933

export default () => {
  const container = useRef<HTMLUListElement>(null)
  const [t] = useTranslation('socialNetworksPage')

  const listBenefits = [
    {
      icon: 'fa-shield-check',
      text: t('empty.listBenefits.1'),
    },
    {
      icon: 'fa-image-slash',
      text: t('empty.listBenefits.2'),
    },
    {
      icon: 'fa-rocket-launch',
      text: t('empty.listBenefits.3'),
    },
    {
      icon: 'fa-link',
      text: t('empty.listBenefits.4'),
    },
  ]

  useLayoutEffect(() => {
    const updateSize = () => {
      if (container.current) {
        const pageContainer = container.current.parentElement?.parentElement?.parentElement
        const wrapperContainer = container.current.parentElement?.parentElement
        const thisContainer = container.current
        const newHeight =
          innerWidth < WIDTH_FOR_MOBILE && innerHeight < HEIGHT_IPHONE_14_PRO_MAX
            ? `${(pageContainer?.clientHeight ?? 0) - (wrapperContainer?.clientHeight ?? 0) + thisContainer.clientHeight - 25}px`
            : 'auto'

        container.current.style.height = newHeight
      }
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  })

  return (
    <div className="empty-social-networks">
      <HeaderComponent />
      <SocialConnect />
      <main className="px-5 py-3">
        <ul className="list-benefits" ref={container}>
          {listBenefits?.map((benefit) => (
            <li key={benefit?.icon}>
              <div className="display-flex">
                <i className={`fa-light ${benefit?.icon}`}></i>
                <p dangerouslySetInnerHTML={{ __html: benefit?.text }} />
              </div>
            </li>
          ))}
        </ul>
        <Button
          width={window.innerWidth < 991 ? '100%' : 'auto'}
          className="mt-5"
          onClick={() => onSocialNetworkConnection.next({ connect: true })}
        >
          {t('empty.button')}
        </Button>
      </main>
    </div>
  )
}
